import { Dots } from "@/shared/icons";
import { TableActionWrapper, IconWrapper, MenuAction, MenuActions } from "./style";
import { TableActionProps } from "./TableAction.types";
import { ForegroundColors } from "@abel-technologies-as/components";

const TableAction = ({ mainIcon, actions, onMouseEnter, onMouseLeave }: TableActionProps) => {
	const showMainIcon = mainIcon ? mainIcon : <Dots color={ForegroundColors.Quinary} width="20" height="20" />;

	return (
		<TableActionWrapper onMouseEnter={() => onMouseEnter?.()} onMouseLeave={() => onMouseLeave?.()}>
			{showMainIcon && <IconWrapper className="icon-wrapper">{showMainIcon}</IconWrapper>}
			<MenuActions className="actions">
				{actions.map((action) => (
					<MenuAction key={action.id} onClick={action.onClick}>
						{action.render ? action.render() : action.icon}
						{action?.renderDropDown?.() ?? null}
					</MenuAction>
				))}
			</MenuActions>
		</TableActionWrapper>
	);
};

export { TableAction };
